import { I18NConfig } from 'next/dist/server/config-shared'
import { getAddons, getPlans } from 'common/planData'
import {
  BusinessServiceOffer,
  getBusinessServices,
} from 'common/businessServices'
import ThanksContent, { ThanksContentProps } from 'components/ThanksContent'
import PageContainer from 'components/util/containers/PageContainer'
import { NextPageWithLayout } from '../../types/nextPageWithLayout'
import { Tenant } from 'common/tenant'

const ThanksPage: NextPageWithLayout<ThanksContentProps> = (props) => (
  <ThanksContent {...props} tenant={Tenant.AU} />
)

ThanksPage.getLayout = (page: React.ReactNode) => (
  <PageContainer tenant={Tenant.AU}>{page}</PageContainer>
)

export async function getStaticProps(
  context: I18NConfig & { locale?: string; params: { uid: string } },
) {
  const tenantId = String(Tenant.AU)
  try {
    const [addons, plans, businessServices] = await Promise.all([
      getAddons(false, tenantId),
      getPlans(true, tenantId),
      getBusinessServices(tenantId).catch(() => [] as BusinessServiceOffer[]),
    ])
    return {
      props: {
        addons,
        businessServices,
        plans,
      },
    }
  } catch (e) {
    return {
      props: {},
    }
  }
}

export default ThanksPage
